import { render, staticRenderFns } from "./CreditNoteList.vue?vue&type=template&id=503d8c45&scoped=true"
import script from "./CreditNoteList.vue?vue&type=script&lang=js"
export * from "./CreditNoteList.vue?vue&type=script&lang=js"
import style0 from "./CreditNoteList.vue?vue&type=style&index=0&id=503d8c45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503d8c45",
  null
  
)

export default component.exports